import { tokenize } from 'linkifyjs';

/** `[https://a.com](https://a.com)` — linkify treats `](https://…)` as the first URL's path. */
const MARKDOWN_LINK_FENCE = /\]\((?:https?:\/\/|www\.)/i;

const normalizePreviewHref = url =>
  String(url || '')
    .trim()
    .replace(/\/+$/, '')
    .toLowerCase();

export function trimMarkdownAutolinkJunk(url) {
  const raw = String(url || '');
  const cut = raw.search(MARKDOWN_LINK_FENCE);
  if (cut === -1) return url;
  const label = raw.slice(0, cut);
  const dest = raw.slice(cut).match(/^\]\((https?:\/\/[^\s)]+|www\.[^\s)]+)/i);
  if (!dest) return label;
  let target = dest[1];
  if (/^www\./i.test(target)) {
    target = `https://${target}`;
  }
  if (normalizePreviewHref(label) === normalizePreviewHref(target)) {
    return label;
  }
  return target;
}

/** Replace `[labelUrl](destUrl)` with dest so previews follow the click target. */
export function unwrapMarkdownAutolinks(text) {
  return String(text || '').replace(
    /\[((?:https?:\/\/|www\.)[^\]\s]+)\]\(((?:https?:\/\/|www\.)[^)\s]+)\)/gi,
    (_, _label, dest) => (/^www\./i.test(dest) ? `https://${dest}` : dest),
  );
}

/**
 * URLs from chat message text for link-preview batching.
 * Drops markdown `[url](url)` fence leftovers and de-dupes.
 */
export default function extractMessagePreviewUrls(text) {
  if (!text) return [];
  const seen = new Set();
  const out = [];
  for (const token of tokenize(unwrapMarkdownAutolinks(text))) {
    if (!token.isLink) continue;
    const obj = token.toObject('https');
    if (obj.type !== 'url') continue;
    obj.href = trimMarkdownAutolinkJunk(obj.href);
    if (!obj.href || seen.has(obj.href)) continue;
    seen.add(obj.href);
    out.push(obj);
  }
  return out;
}
